import {UserStripeService} from "../../../stripe/service/UserStripeService";
import {StoreViewStore} from "../../common/services/StoreViewStore";
import {TfStoreProduct} from "../models/TfStoreProduct";
import {TfStoreService} from "./TfStoreService";

export class TfStoreViewStore extends StoreViewStore<TfStoreProduct> {
    public billingCycle: "MONTH" | "YEAR" = "MONTH";
    private constructor(tfStoreService: TfStoreService, userStripeService: UserStripeService) {
        super(tfStoreService, userStripeService);
    }
    public setBillingCycle(cycle: "MONTH" | "YEAR") {
        this.billingCycle = cycle;
    }
    public toggleTestProductState() {
        this.toggleProductState(TfStoreProduct.TRADEFLOOR_PRO);
    }

    public static initialize(storeService: TfStoreService, userStripeService: UserStripeService): TfStoreViewStore {
        return new TfStoreViewStore(storeService, userStripeService);
    }
}
